import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpResponse } from '@angular/common/http';

// ** rxjs
import { Observable, of } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';

// ** env
import { config } from '@app/core/app.config';

// ** service
import { ErrorCatchService } from './errorCatch.service';

@Injectable({
	providedIn: 'root',
})
export class NewsService {
	constructor(
		private http: HttpClient,
		private router: Router,
		private httpClient: HttpClient,
		private errorCatchService: ErrorCatchService
	) {}

	// - 取得最新消息 (總覽)
	getLatestNews(): Observable<any> {
		const fileName = 'latest-news-sheet.json';
		return this.httpClient.get(`${config.news}/latest/${fileName}`).pipe(
			map((res) => res),
			catchError(this.errorCatchService.handler)
		);
	}

	// - 取得新聞 (總覽)
	getNews(): Observable<any> {
		const fileName = 'news-sheet.json';
		return this.httpClient.get(`${config.news}/news/${fileName}`).pipe(
			map((res) => res),
			catchError(this.errorCatchService.handler)
		);
	}

	// - 取得電子報 (總覽)
	getElectronicNews(): Observable<any> {
		const fileName = 'electronic-news-sheet.json';
		return this.httpClient.get(`${config.news}/electronic/${fileName}`).pipe(
			map((res) => res),
			catchError(this.errorCatchService.handler)
		);
	}

	// - 取得全文章
	getFullPiece(type: 'latest' | 'electronic' | 'news', file: string) {
		const fileName = file;
		return this.httpClient.get(`${config.news}/${type}/${fileName}`).pipe(
			map((res) => res),
			catchError(this.errorCatchService.handler)
		);
	}
}
